<template>
  <div class="component">
    <div class="component-title" style="margin-bottom: 8px;">二次费用</div>
    <table style="margin-bottom: 4px;">
      <tbody>
        <tr style="height: 32px;">
          <th>规则</th>
          <th>等候费用</th>
        </tr>
        <tr style="height: 44px;">
          <td width="23%" style="font-size: 14px;font-family: DIN-Medium;">不超过{{carAttributeFeeConfig.freeWaitHourTime | filterMinutes}}分钟</td>
          <td width="77%" style="font-size: 12px;color: #EC892E;">免费</td>
        </tr>
        <tr style="height: 44px;">
          <td width="23%" style="font-size: 14px;font-family: DIN-Medium;">超过{{carAttributeFeeConfig.freeWaitHourTime | filterMinutes}}分钟</td>
          <td width="77%" style="font-size: 12px;">
            <div>按每小时{{carAttributeFeeConfig.ltTwentyFourHoursHourUnitFee}}元收费</div>
            <div>（不足1小时按1小时计算）</div>
          </td>
        </tr>
        <tr style="height: 44px;">
          <td width="23%" style="font-size: 14px;font-family: DIN-Medium;">每24小时封顶</td>
          <td width="77%" style="font-size: 12px;">{{carAttributeFeeConfig.twentyFourHoursLimitMaxFee}}元</td>
        </tr>
        <tr style="height: 44px;">
          <td width="23%" style="font-size: 14px;font-family: DIN-Medium;">超出24小时</td>
          <td width="77%" style="font-size: 12px;">
            <div>按每小时{{carAttributeFeeConfig.gtTwentyFourHoursUnitFee}}元收费</div>
            <div>（不足1小时按1小时计算）</div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="display: flex;">
      <div style="width: 6px;height: 6px;border-radius: 50%;overflow: hidden;background-color: #EC892E;margin-right: 4px;flex-shrink: 0;margin-top: 6px;"></div>
      <div style="font-size: 12px;line-height: 20px;">等候时长：合计每个装卸点，从司机到达，至装卸货完成离开的时间（包括排队、装卸、等待文件处理等）</div>
    </div>
  </div>
</template>

<script>
export default {
  name:"SecondaryFee",
  props:["carAttributeFeeConfig"],
  filters:{
    filterMinutes(value){
      return value * 60;
    }
  }
}
</script>

<style scoped lang="scss">
 table,
  th,
  td {
    border: 1px solid #C9C2BB;
  }

  table {
    width: 100%;
    margin: 0 auto;
    display: table;
    border-spacing: 0;
    border-radius: 4px;
    overflow: hidden;
  }
  th,
  td {
    border-top-width: 0;
    border-left-width: 0;
    text-align: center;
  }
  th {
    font-weight: 500;
    background-color: #F8F8F8;
  }

  th:last-child,
  td:last-child {
    border-right-width: 0;
  }

  tr:last-child td {
    border-bottom-width: 0;
  }

  td tr td{
    border-top: 1px solid #C9C2BB;
  }
  td tr:first-child td {
    border-top: 0;
    border-bottom: 0;
  }
</style>